import React from "react";
import { Modal, Button } from "react-bootstrap";

const InsuranceDetailModal = ({ show, onHide, insurance }) => {
  if (!insurance) return null;
  const formatDate = (dateString) => {
    if (!dateString || isNaN(Date.parse(dateString))) return "-"; // or return "" if you prefer blank
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Document Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Vehicle Number:</strong>{" "}
          {insurance.vehicleId ? insurance.vehicleId.numberplate : "-"}
        </p>
        <p>
          <strong>Leasing Partner:</strong>{" "}
          {insurance.leaseId ? insurance.leaseId.leasing_partner : "-"}
        </p>
        <p>
          <strong>Client Name:</strong>{" "}
          {insurance.clientId ? insurance.clientId.name : "-"}
        </p>
        <p>
          <strong>Document Type:</strong>{" "}
          {insurance.documenttypeId ? insurance.documenttypeId.name : "-"}
        </p>
        <p>
          <strong>Amount:</strong> {insurance.amountPaid}
        </p>
        <p>
          <strong>Due Date : </strong> {formatDate(insurance.Date)}
        </p>
        <p>
          <strong> Done Date : </strong> {formatDate(insurance.DoneDate)}
        </p>
        <p>
          <strong>POC Name:</strong> {insurance.pocName}
        </p>
        <p>
          <strong>POC Contact:</strong> {insurance.pocContact}
        </p>
        <p>
          <strong>State:</strong> {insurance.state}
        </p>
        <p>
          <strong>Comments:</strong> {insurance.comments}
        </p>
        <p>
          <strong>Created Date : </strong> {formatDate(insurance.createdAt)}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InsuranceDetailModal;
